import { Defs, ClipPath, G, Path, Svg } from "@react-pdf/renderer";
import { SvgIconProps } from "./SvgIconProps";

const YoutubeIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <Svg viewBox="0 0 224.87999 225" {...props}>
      <Defs>
        <ClipPath id="youtubeClip">
          <Path d="M 9.308594 42 L 215.445312 42 L 215.445312 182.90625 L 9.308594 182.90625 Z M 9.308594 42" />
        </ClipPath>
      </Defs>
      <G clipPath="url(#youtubeClip)">
        <Path
          fill={props.color}
          d="M 206.808594 55.585938 C 201.222656 45.695312 195.15625 43.878906 182.8125 43.183594 C 170.480469 42.351562 139.46875 42.003906 112.609375 42.003906 C 85.691406 42.003906 54.667969 42.351562 42.347656 43.167969 C 30.03125 43.878906 23.808594 45.683594 18.171875 55.585938 C 12.414062 65.464844 9.308594 82.484375 9.308594 112.441406 L 9.308594 112.542969 C 9.308594 142.371094 12.414062 159.515625 18.167969 169.289062 C 23.804688 179.183594 29.941406 180.976562 42.261719 181.808594 C 54.59375 182.527344 85.652344 182.949219 112.570312 182.949219 C 139.433594 182.949219 170.460938 182.527344 182.804688 181.820312 C 195.148438 180.992188 201.222656 179.195312 206.808594 169.304688 C 212.613281 159.527344 215.5625 142.382812 215.5625 112.554688 L 215.5625 112.453125 C 215.5625 82.484375 212.625 65.464844 206.808594 55.585938 Z M 86.652344 150.917969 L 86.652344 74.039062 L 151.015625 112.476562 Z M 86.652344 150.917969"
          fillOpacity={1}
          fillRule="nonzero"
        />
      </G>
    </Svg>
  );
};

export default YoutubeIcon;
